import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './store';
import { profileInitialize, profileRequest } from './store/profile/profile.actions';
import { RouterOutlet } from '@angular/router';
import { UpdateService } from './modules/shared/services/update.service';
import { UpdateNotificationComponent } from './modules/shared/components/update-notification/update-notification.component';
import { AuthService } from './modules/shared/services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, UpdateNotificationComponent]
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'noviship-consumer';

    constructor(private store: Store<AppState>, private updateService: UpdateService,
                private authService: AuthService) {
    }

    ngOnInit(): void {
        // Check for a token handoff query parameter before normal bootstrap.
        // The server will exchange the token for an HttpOnly cookie and redirect back.
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token')?.trim();
            if (token) {
                // Redirect to the token-handoff endpoint; do not continue normal bootstrap.
                this.authService.redirectToTokenHandoff(token);
                return;
            }
        }

        if (this.hasExternalReferrer() || this.authService.consumeTokenHandoffProfileRefresh()) {
            this.store.dispatch(profileRequest({ useCache: false }));
        } else {
            this.store.dispatch(profileInitialize());
        }
        this.updateService.initialize();
    }

    ngOnDestroy(): void {
        this.updateService.destroy();
    }

    private hasExternalReferrer(): boolean {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return false;
        }

        const referrer = document.referrer?.trim();
        if (!referrer) {
            // Typed URL, bookmark, or referrer suppressed.
            return true;
        }

        try {
            const referrerUrl = new URL(referrer);
            const currentUrl = new URL(window.location.href);

            // Exact same origin counts as internal navigation.
            return referrerUrl.origin !== currentUrl.origin;
        } catch {
            return false;
        }
    }

}
